import SendingRateToken from '@apps/maha/admin/tokens/sending_rate_token'
import Panel from '@admin/components/panel'

const mapPropsToPanel = (props, context) => ({
  title: 't(Segments)',
  collection: {
    endpoint: `/api/admin/truevail/admin/deliverability/domains/${props.domain.id}/domain_segments`,
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Segment)', key: 'segment.text', sort: 'segment' },
      { label: 't(Queued)', key: 'queued_count', collapsing: true, align: 'right' },
      { label: 't(Rate)', key: 'sending_rate', collapsing: true, align: 'right', format: SendingRateToken }
    ],
    defaultSort: { key: 'segment', order: 'asc' },
    empty: {
      svg: 'network',
      title: 't(No Domain Segments)',
      text: 't(There are no domain segments)'
    },
    entity: 'domain segment',
    recordTasks: (record) => [
      {
        label: 't(Promote Emails)',
        confirm: 't(Are you sure you want to bypass the queue and deliver these emails?)',
        request: {
          endpoint: `/api/admin/truevail/admin/deliverability/domain_segments/${record.id}/promote`,
          method: 'PATCH'
        }
      }
    ],
    onClick: (record) => context.router.push(`/admin/truevail/admin/domain_segments/${record.id}`)
  }
})

export default Panel(null, mapPropsToPanel)
